// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__XMdsc","onlyIcon":"Button_onlyIcon__5tR3r","Icon":"Button_Icon__AJyrb","iconRight":"Button_iconRight__rQpdZ","iconLeft":"Button_iconLeft__C77mI"};